import React, { useState } from 'react';
import toast from 'react-hot-toast';
import jobListingsService from '../../services/JobListingsService';

/**
 * Puts one draft live. Sits next to the status badge, so it only renders for
 * drafts and disappears once the reload shows the job as published.
 */
export function PublishButton({ job, canEdit, onPublished }) {
  const [publishing, setPublishing] = useState(false);

  if (job.status !== 'draft' || !canEdit) return null;

  async function publish() {
    setPublishing(true);
    const result = await jobListingsService.publishJob(job.id);
    setPublishing(false);

    if (!result.success) {
      toast.error(result.error);
      return;
    }
    toast.success(`„${job.title}“ ist veröffentlicht`);
    onPublished?.();
  }

  return (
    <button
      type="button"
      onClick={publish}
      disabled={publishing}
      className="inline-flex items-center rounded-full border border-emerald-300 dark:border-emerald-700 bg-white dark:bg-slate-800 px-2.5 py-0.5 text-xs font-semibold text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 transition-colors disabled:opacity-60 disabled:cursor-wait"
    >
      {publishing ? 'Wird veröffentlicht …' : 'Veröffentlichen'}
    </button>
  );
}
